import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { api } from './api';
import { clearUserData, getNewStateByAttr, getNewStateById } from './entities';
const initialState = {
    add: {
        failures: [],
        successes: []
    },
    byId: {},
    byUsername: {},
    status: 'init',
    usernames: []
};
export const addFriends = createAsyncThunk('friends/add', async (usernames, thunkApi) => {
    const { friends } = thunkApi.getState();
    const { byUsername } = friends;
    const addFriendsData = usernames.reduce((data, username) => {
        if (typeof byUsername[username] === 'undefined') {
            data.usernames.push(username);
        }
        return data;
    }, {
        usernames: []
    });
    try {
        const result = await (await api.instance).addFriends(addFriendsData);
        thunkApi.dispatch(fetchFriends());
        return result;
    }
    catch (error) {
        return thunkApi.rejectWithValue(error);
    }
});
export const removeFriend = createAsyncThunk('friends/remove', async (userId, thunkApi) => {
    try {
        const result = await (await api.instance).removeFriend(userId);
        thunkApi.dispatch(fetchFriends());
        return result;
    }
    catch (error) {
        return thunkApi.rejectWithValue(error);
    }
});
export const fetchFriends = createAsyncThunk('friends/fetch', async (_, thunkApi) => {
    try {
        return await (await api.instance).fetchFriends();
    }
    catch (error) {
        return thunkApi.rejectWithValue(error);
    }
});
function isSubmittingAction(action) {
    return [addFriends.pending.type, removeFriend.pending.type].includes(action.type);
}
function isRejectedAction(action) {
    return action.type.startsWith('friends/') && action.type.endsWith('/rejected');
}
const friendsSlice = createSlice({
    name: 'friends',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(clearUserData.fulfilled, (state) => (state = initialState))
            .addCase(addFriends.fulfilled, (state, action) => {
            state.add = action.payload;
            state.status = 'success';
        })
            .addCase(fetchFriends.fulfilled, (state, action) => {
            state.byId = getNewStateById({}, action.payload);
            state.byUsername = getNewStateByAttr(state.byId, 'username');
            state.usernames = Object.keys(state.byUsername);
            state.status = 'success';
        })
            .addCase(removeFriend.fulfilled, (state) => {
            state.status = 'success';
        })
            .addCase(fetchFriends.pending, (state) => {
            state.status = 'fetching';
        })
            .addMatcher(isSubmittingAction, (state) => {
            state.status = 'submitting';
        })
            .addMatcher(isRejectedAction, (state) => {
            state.status = 'error';
        });
    }
});
export const friendsReducer = friendsSlice.reducer;
